export default __webpack_public_path__ + "static/media/my-rentals.2ce4a095.svg";